import { format } from 'date-fns'
import isNil from 'lodash-es/isNil'

import { CalendarAppointmentStatus } from '../../constants/calendar'
import {
  DATE_FULL_FORMAT_FROM_TIME,
  DATE_SHORT_FORMAT,
} from '../../constants/date'
import { toUkTimezoneDate } from '../../utils/date'

import {
  APPOINTMENT_REMINDER_NONE,
  AppointmentFollowUpAction,
  AppointmentParticipantKind,
  APPOINTMENTS_LOADING_STATE,
} from './Appointment.constants'

export function getIsAppointmentCancelled(status) {
  return status === CalendarAppointmentStatus.cancelled
}

export function getIsAppointmentExternalParticipant(participant) {
  return participant.kind === AppointmentParticipantKind.external
}

export function getIsAppointmentFollowUpApply(action) {
  return action === AppointmentFollowUpAction.apply
}

export function getIsAppointmentReminderNone(minutes) {
  return minutes === APPOINTMENT_REMINDER_NONE
}

export function hasAppointmentFollowUpPrompt(appointment) {
  return !isNil(appointment.follow_up_prompt)
}

export function getAppointmentsRequestKey(params) {
  return params ? JSON.stringify(params, Object.keys(params).sort()) : null
}

// A list row reads the time first; an all-day row shows the date only (CAL-02 §11.5)
export function getAppointmentListDateLabel({ appointment, timezone }) {
  return format(
    toUkTimezoneDate(appointment.start_at, timezone),
    appointment.is_all_day ? DATE_SHORT_FORMAT : DATE_FULL_FORMAT_FROM_TIME
  )
}

export function getAppointmentsState({ requestKey, response }) {
  return response.requestKey === requestKey
    ? response
    : APPOINTMENTS_LOADING_STATE
}
